import React, { useEffect } from "react";
import { Link } from "react-scroll";
import MobileMenu from "../MobileMenu/MobileMenu";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import menus from "../../api/menus";

const Header = (props) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 500,
      once: false,
    });
  }, []);

  return (
    <header id="header">
      <div className={" " + props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <MobileMenu />
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="navbar-header" data-aos="fade-right">
                  <a
                    className="navbar-brand"
                    href="/"
                    aria-label="Logo CreaSnap"
                    rel="noreferrer"
                  >
                    <img
                      src={props.Logo}
                      alt="CreaSnap"
                      fetchpriority="high"
                      width="100%"
                      height="auto"
                    />
                  </a>
                </div>
              </div>
              <div className="col-lg-7 col-md-1 col-1" data-aos="fade-down">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    {menus.map((menu, mindex) => (
                      <li key={mindex}>
                        {isHome ? (
                          <Link
                            activeClass="active"
                            className={menu.link === "home" ? "active" : ""}
                            to={menu.link}
                            spy={true}
                            smooth={true}
                            offset={menu.offset}
                            duration={500}
                            aria-label={menu.label}
                          >
                            {menu.title}
                          </Link>
                        ) : (
                          // eslint-disable-next-line jsx-a11y/anchor-has-content
                          <a href="/" rel="noreferrer" aria-label={menu.label}>
                            {menu.title}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-2 col-2" data-aos="fade-left">
                <div className="header-right">
                  <a
                    href={`https://api.whatsapp.com/send?phone=${props.contact.telephone.username}`}
                    className="call-number"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Menuju Halaman Ke kontak Pemesanan"
                  >
                    <div className="icon">
                      <img
                        src={props.telephone}
                        alt="Icon Telephone CreaSnap"
                        fetchpriority="high"
                      />
                    </div>
                    <div className="text">
                      <span className="title">Hotline 24/7</span>
                      <span className="number">
                        +
                        {props.contact.telephone.username
                          .match(/.{1,4}/g)
                          .join("-")}
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
